export default "__VITE_ASSET__Bc$JDpDA__"